import { ShieldCheck, Home, Hammer } from "lucide-react";

export const ROLES = {
  administrador: {
    key: "administrador",
    label: "Administrador",
    path: "/admin",
    icon: ShieldCheck,
    description: "Crea y gestiona proyectos, usuarios y toda la hoja de ruta.",
  },
  cliente: {
    key: "cliente",
    label: "Cliente",
    path: "/portal/cliente",
    icon: Home,
    description: "Sigue el avance de tu vivienda y consulta tus dudas con Mori.",
  },
  colaborador: {
    key: "colaborador",
    label: "Colaborador",
    path: "/portal/colaborador",
    icon: Hammer,
    description: "Arquitectos, aparejadores y constructoras que actualizan tareas.",
  },
};

export const PORTAL_ROLES = ["cliente", "colaborador"];

export function isAdminUser(user) {
  return Boolean(user && (user.is_admin || user.memberships?.some((m) => m.role === "administrador")));
}

export function homePathFor(user) {
  if (!user) return "/";
  if (isAdminUser(user)) return ROLES.administrador.path;
  for (const role of PORTAL_ROLES) {
    if (user.memberships?.some((m) => m.role === role)) return ROLES[role].path;
  }
  return null;
}

export function projectPath(role, projectId) {
  return role === "administrador" ? `/admin/proyectos/${projectId}` : `/portal/${role}/${projectId}`;
}
